import loadable from '@loadable/component';

export const UserDashboardProfilePageLoadable = loadable(
  () => import('./UserDashboardProfilePage'),
  { resolveComponent: (module) => module.UserDashboardProfilePage },
);
